var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$page.props.tabs)?_c('v-tabs',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.$page.props.tabs),function(tab){return _c('v-tab',{key:tab.label,on:{"click":function($event){return _vm.visit(tab)}}},[_vm._v("\n    "+_vm._s(tab.label)+"\n  ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }